export class AddAdditionalEmail {
    static readonly type = '[User] AddAdditionalEmail';

    constructor(public payload: { email: string }) {}
}
